import { ThemeSelectors, TypeFiesta } from '@at/design-system-foundation'
import styled, { css } from 'styled-components'

export const StyledFieldsetPanel = styled.fieldset<{
    hasTitle?: boolean
    singularColumn?: boolean
    compact?: boolean
    singularColumnSmall?: boolean
}>`
    ${({ compact, hasTitle, singularColumn, singularColumnSmall, theme }) => css`
        margin: 0 0 ${ThemeSelectors.getLegacyGridUnit(theme) * 3}px;
        padding: 2px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        border: 0 none;
        width: 100%;
        align-items: flex-start;

        & > div {
            max-width: 50%;
            width: 100%;
        }

        &:last-child {
            margin-bottom: 24px;
        }

        > .search-filters-dropdown-container {
            display: block;
            width: calc(50% - ${ThemeSelectors.getGridUnit(theme)});

            &:only-child {
                width: 100%;
            }
        }

        .search-filters__quad-layout {
            > .search-filters-dropdown-container {
                &:nth-last-child(-n + 2) {
                    margin-bottom: 0;
                }

                margin-bottom: ${ThemeSelectors.getLegacyGridUnit(theme) * 4}px;
            }
        }

        & button[data-name='use-device-location-button'] {
            /* Mobile use-device-location-button styles */
            margin-top: ${ThemeSelectors.getLegacyGridUnit(theme) * 3}px;
            height: 40px;
        }

        & button[data-name='new-use-device-location-button'] {
            /* Mobile use-device-location-button styles */
            margin-top: ${ThemeSelectors.getLegacyGridUnit(theme) * 3}px;
            height: 54px;
        }

        ${singularColumn &&
        css`
            & > div {
                max-width: 100%;
                margin-bottom: 24px;
            }

            &:last-child {
                margin-bottom: 0;
            }

            width: 100%;

            > .search-filters-dropdown-container,
            > .saved-search-select {
                width: 100%;
            }
        `}
        ${singularColumnSmall &&
        css`
            @media (max-width: 576px) {
                && > div {
                    margin: 0 0 ${ThemeSelectors.getLegacyGridUnit(theme) * 4}px 0;
                    max-width: none;
                    width: 100%;
                }

                && > div:nth-child(3),
                && > div:nth-child(2) {
                    margin-bottom: 0;
                }

                flex-direction: column;
            }
        `}
    ${hasTitle &&
        css`
            padding: ${ThemeSelectors.getGridUnit(theme)} ${ThemeSelectors.getLegacyGridUnit(theme) * 2}px
                ${ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
            border: 1px solid ${theme.color.border.disabled};
        `}
    ${compact &&
        css`
            margin-bottom: ${ThemeSelectors.getGridUnit(theme)};
        `}
    `}
`

export const StyledFieldsetPanelLegend = styled(TypeFiesta)`
    color: ${({ theme }) => theme.color.text.title};
    padding: 0 ${({ theme }) => ThemeSelectors.getGridUnit(theme)};
    background-color: ${({ theme }) => theme.color.bgSurface.default};
`
